export enum ACCOUNT_METHODS {
  STANDARD = 'STANDARD',
  INSTANT = 'INSTANT',
}
